import api from './api';

export interface RespuestaEvaluacion {
  pregunta_id: number;
  respuesta: boolean;
}

export interface CrearEvaluacionPayload {
  cedula_capacitador: string;
  puntaje: number;
  comentario?: string;
  recomendacion?: string;
  respuestas: RespuestaEvaluacion[];
}

export default {
  obtenerCapacitadoresTecnicos() {
    return api.get('evaluacion-capacitacion/capacitadores');
  },
  obtenerPreguntas() {
    return api.get('evaluacion-capacitacion/preguntas');
  },
  crearEvaluacion(payload: CrearEvaluacionPayload) {
    return api.post('evaluacion-capacitacion/', payload);
  },
};
